export default __webpack_public_path__ + "static/media/info.bb76f5b8.png";